
export class WidgetContent {

  public Id: string;
  public widgetContentID: number;
  public pageWidgetID: number;
  public data: string;
  public type: string;
  public isActive: boolean;
  public createdBy: number;
  public createdDate: Date;

}



// WEBPACK FOOTER //
// ./src/app/models/widget/widget-content.model.ts